<template>
  <a-carousel
    arrows
    easing="linear"
    :speed="1500"
    :autoplaySpeed="6000"
    autoplay
  >
    <template #prevArrow>
      <div class="custom-slick-arrow" style="left: 10px; zindex: 1">
        <left-circle-outlined />
      </div>
    </template>
    <template #nextArrow>
      <div class="custom-slick-arrow" style="right: 10px; zindex: 10">
        <right-circle-outlined />
      </div>
    </template>
    <div
      v-for="image in BannerSlider"
      :key="image.fileId"
      class="carousel_item"
    >
      <template v-if="image.url">
        <a
          :href="image.url ?? ''"
          target="_blank"
          :style="`background-image: url(${image.filePath}); background-size: contain;background-repeat: no-repeat;`"
          title="[另開新視窗]中華民國外交部全球資訊網"
        >
          <img :src="image.filePath" alt="國人海外網站公告視覺圖片" />
        </a>
      </template>
      <img v-else :src="image.filePath" alt="國人海外就業中心網站公告圖" />
    </div>
  </a-carousel>
</template>
<script>
import { LeftCircleOutlined, RightCircleOutlined } from "@ant-design/icons-vue";
import { defineComponent, reactive } from "vue";
import { apiBannerSlider } from "@/api/api.js";

export default defineComponent({
  name: "BannerSlide",
  components: {
    LeftCircleOutlined,
    RightCircleOutlined,
  },
  setup() {
    const BannerSlider = reactive([]);
    apiBannerSlider()
      .then((res) => {
        res.data.forEach((image) => {
          BannerSlider.push(image);
        });
      })
      .catch((err) => {
        console.log(err);
      });
    return {
      BannerSlider,
    };
  },
});
</script>
<style scoped lang="scss">
.carousel_item {
  height: 396px;
}
@media screen and (max-width: 1700px) {
  .carousel_item {
    height: 355px;
  }
}
@media screen and (max-width: 1600px) {
  .carousel_item {
    height: 333px;
  }
}
@media screen and (max-width: 1500px) {
  .carousel_item {
    height: 311px;
  }
}
@media screen and (max-width: 1440px) {
  .carousel_item {
    height: 300px;
  }
}
@media screen and (max-width: 1400px) {
  .carousel_item {
    height: 291px;
  }
}
@include lg {
  .carousel_item {
    height: 205px;
  }
}
@media screen and (max-width: 900px) {
  .carousel_item {
    height: 187px;
  }
}
@media screen and (max-width: 860px) {
  .carousel_item {
    height: 179px;
  }
}
@include md {
  .carousel_item {
    height: 159px;
  }
}
@media screen and (max-width: 700px) {
  .carousel_item {
    height: 146px;
  }
}
@media screen and (max-width: 650px) {
  .carousel_item {
    height: 135px;
  }
}
@include sm {
  .carousel_item {
    height: 119px;
  }
}
@include xs {
  .carousel_item {
    height: 100px;
  }
}
@media screen and (max-width: 420px) {
  .carousel_item {
    height: 88px;
  }
}
@include xxs {
  .carousel_item {
    height: 78px;
  }
}
</style>
